/**
 * The site's search and share defaults, written by the head manager (2026-09-30; src/config/siteHeadDefaults.ts).
 *
 * MOUNT IT FIRST, inside the one HelmetProvider (src/index.tsx). react-helmet-async keeps, for each tag, the value
 * of the head that registered LAST, and a head registers when it first renders. Mounted first, every page's own head
 * overrides it; mounted after a page, its defaults would override the page's own words.
 *
 * The shell (public/index.html) carries the same tags, marked `data-rh="true"`, so the head manager's first write
 * keeps each one it would write identically and replaces the rest. Without this component a page that writes only
 * some of them (the page for lawyers writes no picture) would lose the others, because the manager removes every
 * marked tag it was not asked to write.
 */
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_DEFAULT_TAGS } from '../config/siteHeadDefaults';

const SiteDefaultHead: React.FC = () => (
  <Helmet>
    {SITE_DEFAULT_TAGS.map((tag) =>
      tag.attribute === 'name'
        ? <meta key={tag.key} name={tag.key} content={tag.content} />
        : <meta key={tag.key} property={tag.key} content={tag.content} />,
    )}
  </Helmet>
);

export default SiteDefaultHead;
